import { navigateToUrlWithPostRequest } from '@tools/helpers';

export function handleUnauthorized(sessieVerlaten?: boolean) {
  const loginUrl = new URL('/Identity/Authentication/Login', window.location.href);
  loginUrl.searchParams.append(
    'returnUrl',
    sessieVerlaten
      ? '/identity/user/verlaten'
      : `${window.location.pathname}${window.location.search}`,
  );
  const relativeLoginUrl = loginUrl.pathname + loginUrl.search;

  navigateToUrlWithPostRequest(
    `/Identity/Authentication/Logout?returnUrl=${relativeLoginUrl}&expired=true`,
  );
}

export function signOut(sessieVerlaten?: boolean) {
  const returnUrl = sessieVerlaten ? '/identity/user/verlaten' : '';

  navigateToUrlWithPostRequest(`/Identity/Authentication/Logout?returnUrl=${returnUrl}`);
}
